import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { RavIcon } from '@shared/icon/icon';
import { SidebarMenu } from '@shared/layout/sidebar-menu/sidebar-menu.type';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { MobileService } from '@shared/services/mobile.service';

@Component({
  selector: 'rav-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  @Input() sidebarMenus: SidebarMenu[];
  @Input() logoSrc = '/assets/svgs/raven-logo.svg';

  @ViewChild('sidenav') sidenav: MatSidenav;
  isSidebarCollapsed: boolean;
  RavIcon = RavIcon;

  constructor(public mobile: MobileService, public localStorage: LocalStorageService, private router: Router) {}

  /**
   * When resizing the window the logo must be the big one if the side bar is not collapsed
   *
   * @param event window resize event
   */
  @HostListener('window:resize', ['$event'])
  changeLogoOnRezise(event): void {
    if (event.target.innerWidth > 1023 && this.isSidebarCollapsed) {
      this.logoSrc = '/assets/images/raven-bird.png';
    } else {
      this.logoSrc = '/assets/svgs/raven-logo.svg';
    }
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (this.sidenav) this.sidenav.close();
    });
  }

  isAdminPage(): boolean {
    return this.router.url.includes('/admin');
  }

  /**
   * When th sidebar is collapsed emits an event and this function listen for the change
   * to update the flag and change the class for the sidebar component
   *
   * @param isCollapsed boolean
   */
  onSidebarCollapse(isCollapsed): void {
    this.isSidebarCollapsed = isCollapsed;
    this.logoSrc = isCollapsed ? '/assets/images/raven-bird.png' : '/assets/svgs/raven-logo.svg';
  }
}
